import React, {useRef} from 'react';
import {SearchBar, useSearch} from '../../Components/Search';
import Form, { Select, TextField, Actions, Checkboxes, User, Week, DateTime, Frequency } from '../../Components/Form';
import { useModal } from '../../Components/Modal';
import { useRounds } from '../../Data/Rounds';
import { statuses } from '../../Data/Jobs';
import { useSession } from '../../Components/Session';

const Search = ({isLoading}) => {
    const {searchData, setSearchData} = useSearch();
    const submitRef = useRef();

    const form = <FilterForm data={searchData} updateSearch={setSearchData} submitRef={submitRef} />;

    return <SearchBar filterForm={form}
                isLoading={isLoading}
                modalOptions={{
                    title: 'Search jobs',
                    theme: 'primary',
                    icon: 'MagnifyingGlass',
                    initialFocus: submitRef,
                }}
            />
}

const FilterForm = ({data, updateSearch, submitRef}) => {
    const {closeModal} = useModal();
    const {rounds} = useRounds();
    const {isAdmin} = useSession();

    const handleSubmit = (data) => {
        updateSearch(data);
        closeModal();
    }

    const clearSearch = () => {
        updateSearch({});
        closeModal();
    }

    return <Form onSubmit={handleSubmit} data={data}>
        <TextField name="search" label="Search" />
        <Select name="roundId" label="In round" options={
            rounds ? [{value: '', label: 'Any'}, ...rounds.map(r => ({value: r.id, label: r.name}))] : [{value: '', label: 'Loading...'}]
        } />
        <Checkboxes name="jobStatuses" label="Status" options={Object.keys(statuses).map(s => ({label: s, value: s}))} />
        <User name="assignedTo" label="Assigned to" unselected="Anyone" />
        <Week name="dueWeek" label="Due week" />
        {isAdmin() && <DateTime name="suggestedDate"
            label="Suggested date"
            time={false}
            showDatePrompts
        />}
        <Frequency name="frequency" label="Frequency" />

        <Actions submit={{label: 'Search', btnRef: submitRef}} cancel={{label: 'Clear', onClick: clearSearch}} />
    </Form>
}

export default Search;
